// removed unused Link import
import { useEffect, useState } from 'react'
import { apiClient, useClientConfig } from '@workspace/public-utils'
import { Seo } from '../../components/Seo'

const TermsPage = () => {
  const config = useClientConfig()
  const [content, setContent] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    const load = async () => {
      try {
        const res = await apiClient.get('/api/v1/public/legal/terms')
        setContent(String(res.data?.content || ''))
      } catch {
        setContent('')
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [])
  return (
    <div className="min-h-screen bg-white dark:bg-gray-950 py-12 px-4 sm:px-6 lg:px-8 transition-colors">
      <Seo
        title="서비스 이용약관"
        description={`${config.brandName} 서비스 이용약관을 확인하세요.`}
        canonicalPath="/terms"
      />
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 dark:text-white">서비스 이용약관</h1>
        <div className="prose max-w-none dark:prose-invert">
          {loading ? (
            <p className="text-gray-500 dark:text-gray-400">불러오는 중...</p>
          ) : content ? (
            <pre className="whitespace-pre-wrap text-sm text-gray-800 dark:text-gray-300">{content}</pre>
          ) : (
            <p className="text-gray-600 dark:text-gray-400 mb-8">본 약관 문서는 아직 준비 중입니다.</p>
          )}
        </div>
      </div>
    </div>
  )
}

export default TermsPage


